import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSchoolByDomain } from '../services/api';

const SchoolContext = createContext({ school: null, subdomain: null, loading: true });

export const useSchool = () => useContext(SchoolContext);

export const getSubdomain = () => {
  const host = window.location.hostname.toLowerCase();
  if (host.endsWith('.soapbox-edu.com')) {
    const sub = host.replace('.soapbox-edu.com', '');
    // Skip environment prefixes and common non-school subdomains
    if (!sub || sub === 'www' || sub === 'dev' || sub === 'staging' || sub === 'api' || sub === 'api-dev') return null;
    // For school subdomains under dev (e.g. myschool.dev.soapbox-edu.com), strip the env part
    if (sub.endsWith('.dev') || sub.endsWith('.staging')) {
      const school = sub.split('.')[0];
      return school || null;
    }
    return sub;
  }
  // Fallback: ?school=xxx for testing on CloudFront/localhost
  return new URLSearchParams(window.location.search).get('school') || null;
};

export const getSchoolDomain = () => {
  const sub = getSubdomain();
  return sub ? `${sub}.soapbox-edu.com` : null;
};

export default function SchoolProvider({ children }) {
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);
  const subdomain = getSubdomain();

  useEffect(() => {
    if (!subdomain) { setLoading(false); return; }
    getSchoolByDomain(subdomain).then(s => {
      setSchool(s);
      if (s?.id) localStorage.setItem('schoolId', s.id);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [subdomain]);

  return (
    <SchoolContext.Provider value={{ school, subdomain, loading }}>
      {children}
    </SchoolContext.Provider>
  );
}
